import { ReactComponent as MenuNewIcon } from "assets/userIcon.svg";
import { ReactComponent as UserlistIcon } from "assets/PwC_Funct_Icons_4Quadrants_Outline_Black_RGB.svg";
import { ReactComponent as RoleManagerIcon } from "assets/PwC_Funct_Icons_DownloadBox_Outline_Black_RGB.svg";
import menuIcon from "assets/usermanagement.png";
import roleManager from "assets/rolemanager.svg";
import userList from "assets/userlist.svg";
import { ReactComponent as UserIcon } from "assets/PwC_Funct_Icons_Avatar_Fill_Black_RGB.svg";
import { HELP_FEATURE_LIST_ACCESS, HELP_DATA_SETS_LIST_ACCESS, PROJECT_SETTING_ACCESS, NORMS_ACCESS, WORKFLOW_ACCESS, DATA_METRICS_ACCESS } from "config";
import { DPR_QUANTITY_ACCESS, DPR_PM_ACCESS, IMAGE_GALLERY_ACCESS, RISK_ACCESS, KEY_ISSUE_ACCESS, KEY_CLEARANCE_ACCESS, SAFETY_ACCESS, QUALITY_ACCESS, CHANGE_ORDER_ACCESS } from "config";
import { CLAIM_ACCESS, VENDOR_PERFORMANCE_TRACKER_ACCESS, PROCUREMENT_ACCESS, FINANCIAL_PROGRESS_ACCESS, PAYMENT_TRACKER_ACCESS, BOQ_ACCESS, CONSTRUCTION_ACCESS, PERMISSION_ACCESS } from "config";
import { SCHEDULE_ACCESS, MILESTONE_ACCESS, ENGINEERING_ACCESS, PM_ACCESS, MONTE_CARLO_SIMULATION_ACCESS, BIM_VIEWER_ACCESS, FILE_ACCESS, USERS_ACCESS, BULK_USER_TRANSACTION_ACCESS, ROLE_ACCESS } from "config";
import { MANPOWER_ACCESS } from "config";
import { PROJECT_HOME_ACCESS } from "config";
import { SMT_SCHEDULE_ACCESS } from "config";
import { SMT_MILESTONE_ACCESS } from "config";
import { SMT_ENGINEERING_ACCESS } from "config";
import { SMT_PM_ACCESS } from "config";
import { SMT_MANPOWERPRODUCT_ACCESS } from "config";
import { FINANCIAL_PROGRESS_DASH_ACCESS } from "config";
import { PAYMENT_TRACKER_DASH_ACCESS } from "config";
import { VENDOR_DASH_ACCESS } from "config";
import { PROCUREMENT_DASH_ACCESS } from "config";
import { CLAIM_AND_CHANGE_ORDER_DASH_ACCESS } from "config";
import { ISSUES_DASH_ACCESS } from "config";
import { KEY_CLEATANCE_DASH_ACCESS } from "config";
import { RISK_DASH_ACCESS } from "config";
import { SAFETY_DASH_ACCESS } from "config";
import { QUALITY_DASH_ACCESS } from "config";
import { PROGRAM_DASHBOARD_MENU } from "config";
import { PROJECT_MENU } from "config";
import { USER_MANAGEMENT_MENU } from "config";
import { PORTFOLIO_DASHBOARD_MENU } from "config";
import { IMAGE_GALLERY_APPROVAL } from "config";
import { ReactComponent as FileView } from "assets/PwC_Funct_Icons_DocumentPage_Fill_Black_RGB.svg";
import { ReactComponent as ProcurementView } from "assets/PwC_Funct_Icons_Document_Fill_Black_RGB.svg"
import { ReactComponent as FaTachometerAltIcon } from "assets/FaTachometerAltIcon.svg";
import { ReactComponent as ListView } from "assets/PwC_Funct_Icons_Menu_Fill_Black_RGB.svg";
import { ReactComponent as ScheduleView } from "assets/PwC_Funct_Icons_Time_Outline_Black_RGB.svg";
import { ReactComponent as ChangeControl } from "assets/PwC_Funct_Icons_News_Fill_Black_RGB.svg";
import { ReactComponent as ProjectView } from "assets/PwC_Funct_Icons_Cost-Dollar_Outline_Black_RGB.svg"
import { ReactComponent as DprView } from "assets/PwC_Funct_Icons_DocumentAlert_Fill_Black_RGB.svg"
import { ReactComponent as GovernanceView } from "assets/PwC_Funct_Icons_ListView_Fill_Black_RGB.svg"
import { ReactComponent as HelpIcon } from "assets/PwC_Funct_Icons_HelpQuestion_Fill_Black_RGB.svg"
import { ReactComponent as ConfigSettingIcon } from "assets/PwC_Funct_Icons_Configuration_Fill_Black_RGB.svg"
import { ReactComponent as ReportIcon } from "assets/PwC_Funct_Icons_NewsReport_Outline_Black_RGB.svg"
import { ReactComponent as ImageIcon } from "assets/PwC_Funct_Icons_Image_Outline_Black_RGB 2.svg"
import { MAIN_ROLES } from "config";

const projectMenus = {
  keymenus: [
    {
      menu: "Project Dashboard",
      icon: <FaTachometerAltIcon style={{ height: "27px", width: "27px", fill: "#696969" }} />,
      route: "",
      permissionKey: [PROJECT_HOME_ACCESS, SMT_SCHEDULE_ACCESS, SMT_MILESTONE_ACCESS, SMT_ENGINEERING_ACCESS, SMT_PM_ACCESS, SMT_MANPOWERPRODUCT_ACCESS,
        FINANCIAL_PROGRESS_DASH_ACCESS, PAYMENT_TRACKER_DASH_ACCESS, VENDOR_DASH_ACCESS, PROCUREMENT_DASH_ACCESS, CLAIM_AND_CHANGE_ORDER_DASH_ACCESS,
        ISSUES_DASH_ACCESS, KEY_CLEATANCE_DASH_ACCESS, RISK_DASH_ACCESS, SAFETY_DASH_ACCESS, QUALITY_DASH_ACCESS
      ],
    },
    {
      menu: "My Work",
      icon: <ListView style={{ height: "27px", width: "27px", fill: "#696969" }} />,
      route: "my-work",
    },
    {
      menu: "Users",
      icon: <UserIcon style={{ height: "27px", width: "27px", fill: "#696969" }} />,
      route: "user",
      permissionKey: [USERS_ACCESS, BULK_USER_TRANSACTION_ACCESS, ROLE_ACCESS, PERMISSION_ACCESS],
      submenus: [
        { name: "User List", route: "list" },
        { name: "Bulk Transactions", route: "bulk-transactions" },
        { name: "Role List", route: "role" },
        { name: "Assign Permission", route: "assign-permission" },
      ],
    },
    {
      menu: "File",
      icon: <FileView style={{ height: "27px", width: "27px", fill: "#696969" }} />,
      mainRoute: "key-file",
      route: "key-file/all-file",
      permissionKey: [FILE_ACCESS],
      childMenu: [
        { name: "All", route: "all-file" },
        { name: "Pending for approval", route: "pending-approval-file" },
        { name: "Submitted by me", route: "file-submitted-by-me" },
      ],
    },
    // {
    //   menu: "Key Issues",
    //   img: userList,
    //   route: "key-issues",
    //   submenus: [
    //     { name: "All", route: "all-issue" },
    //     { name: "Pending", route: "pending-approval" },
    //     { name: "Submitted by me", route: "submitted-by-me" },
    //   ],
    // },
    // {
    //   menu: "Key Risk",
    //   img: userList,
    //   route: "key-risk",
    //   submenus: [
    //     { name: "All", route: "all-risk" },
    //     { name: "Pending", route: "pending-approval-risk" },
    //     { name: "Submitted by me", route: "risk-submitted-by-me" },
    //   ],
    // },
    // {
    //   menu: "Key Clearance",
    //   img: userList,
    //   route: "key-clearance",
    //   submenus: [
    //     { name: "All", route: "all-clearance" },
    //     { name: "Pending", route: "pending-approval-clearance" },
    //     { name: "Submitted by me", route: "clearance-submitted-by-me" },
    //   ],
    // },
    // {
    //   menu: "Safety",
    //   img: userList,
    //   route: "key-safety",
    //   submenus: [
    //     { name: "All", route: "all-safety" },
    //     { name: "Pending", route: "pending-approval-safety" },
    //     { name: "Submitted by me", route: "safety-submitted-by-me" },
    //   ],
    // },

    // {
    //   menu: "Change Order",
    //   img: userList,
    //   route: "key-change-tracker",
    //   submenus: [
    //     { name: "All", route: "all-change-tracker" },
    //     { name: "Pending", route: "pending-approval-change-tracker" },
    //     { name: "Submitted by me", route: "change-tracker-submitted-by-me" },
    //   ],
    // },
    // {
    //   menu: "Claims",
    //   img: userList,
    //   route: "key-claims",
    //   submenus: [
    //     { name: "All", route: "all-claims" },
    //     { name: "Pending", route: "pending-approval-claims" },
    //     { name: "Submitted by me", route: "claims-submitted-by-me" },
    //   ],
    // },
    // {
    //   menu: "Quality",
    //   img: userList,
    //   route: "key-quality",
    //   submenus: [
    //     { name: "All", route: "all-quality" },
    //     { name: "Pending", route: "pending-approval-quality" },
    //     { name: "Submitted by me", route: "quality-submitted-by-me" },
    //   ],
    // },
    {
      menu: "Project Progress and Scheduling",
      icon: <ScheduleView style={{ height: "27px", width: "27px", fill: "#696969", stroke: "#696969", strokeWidth: 2 }} />,
      route: false,
      permissionKey: [CONSTRUCTION_ACCESS, SCHEDULE_ACCESS, MILESTONE_ACCESS, ENGINEERING_ACCESS, PM_ACCESS, MANPOWER_ACCESS, MONTE_CARLO_SIMULATION_ACCESS, BIM_VIEWER_ACCESS],
      submenus: [
        // {
        //   name: "Construction",
        //   mainRoute: "construction",
        //   route: "all",
        // },
        {
          name: "Schedule",
          mainRoute: "key-schedule",
          route: "all-schedule",
        },
        {
          name: "Milestone",
          mainRoute: "key-milestone",
          route: "all-milestone",
          childMenu: [
            { name: "All", route: "all-milestone" },
            {
              name: "Pending for approval",
              route: "pending-approval-milestone",
            },
            { name: "Submitted by me", route: "milestone-submitted-by-me" },
          ],
        },
        {
          name: "Engineering",
          mainRoute: "engineering",
          route: "all-activities",
        },
        {
          name: "Plant & Machinery",
          mainRoute: "key-p&m",
          route: "all-p&m",
          childMenu: [
            { name: "All", route: "all-p&m" },
            { name: "Pending for approval", route: "pending-approval-p&m" },
            { name: "Submitted by me", route: "p&m-submitted-by-me" },
          ],
        },
        {
          name: "Manpower",
          mainRoute: "key-manpower",
          route: "all-manpower",
        },
        {
          name: "Monte Carlo Simulation",
          mainRoute: "monte-carlo-simulation",
          route: "all-monte-carlo-simulation",
        },
        {
          name: "Bim Viewer",
          mainRoute: "bim-viewer",
          route: "all-bim-viewer",
        },
        // {
        //   name: "Productivity",
        //   mainRoute: "productivity",
        //   route: "all",
        // },
      ],
    },
    {
      menu: "Project Cost Control",
      icon: <ProjectView style={{ height: "27px", width: "27px", fill: "#696969", stroke: "#696969", strokeWidth: 2 }} />,
      route: false,
      // permissionKey: [FINANCIAL_PROGRESS_ACCESS, PAYMENT_TRACKER_ACCESS, BOQ_ACCESS],
      permissionKey: [BOQ_ACCESS],
      submenus: [
        // {
        //   name: "Financial progress",
        //   mainRoute: "financial-progress",
        //   route: "all",
        // },
        // {
        //   name: "Payment Tracker",
        //   mainRoute: "payment-tracker",
        //   route: "all",
        // },
        {
          name: "BOQ",
          mainRoute: "key-BOQ",
          route: "all-BOQ",
          childMenu: [
            { name: "All", route: "all-BOQ" },
            { name: "Submitted by me", route: "boqSubmitted" },
          ],
        },
        // {
        //   name: "Cash flow",
        //   mainRoute: "cash-flow",
        //   route: "all",
        // },
      ],
    },
    // {
    //   menu: "Contract and Procurement Lifecycle",
    //   icon: <ProcurementView style={{ height: "27px", width: "27px", fill: "#696969" }} />,
    //   route: false,
    //   permissionKey: [VENDOR_PERFORMANCE_TRACKER_ACCESS, PROCUREMENT_ACCESS],
    //   submenus: [
    //     {
    //       name: "Vendor Performance Tracker",
    //       mainRoute: "vendor-performance-tracker",
    //       route: "all",
    //     },
    //     {
    //       name: "Procurement",
    //       mainRoute: "Procurement",
    //       route: "all",
    //     },
    //     // {
    //     //   name: "Supply",
    //     //   mainRoute: "Supply",
    //     //   route: "all",
    //     // },
    //   ],
    // },
    {
      menu: "Change Control & Claim Tracker",
      icon: <ChangeControl style={{ height: "27px", width: "27px", fill: "#696969" }} />,
      route: false,
      permissionKey: [CHANGE_ORDER_ACCESS, CLAIM_ACCESS],
      submenus: [
        {
          name: "Change Order",
          mainRoute: "key-change-tracker",
          route: "all-change-tracker",
        },
        {
          name: "Claims",
          mainRoute: "key-claims",
          route: "all-claims",
        },
      ],
    },
    {
      menu: "Governance and Compliance",
      icon: <GovernanceView style={{ height: "27px", width: "27px", fill: "#696969", }} />,
      route: false,
      permissionKey: [KEY_ISSUE_ACCESS, RISK_ACCESS, KEY_CLEARANCE_ACCESS, SAFETY_ACCESS, QUALITY_ACCESS],
      submenus: [
        {
          name: "Issues",
          mainRoute: "key-issues",
          route: "all-issue",
          childMenu: [
            { name: "All", route: "all-issue" },
            { name: "Pending", route: "pending-approval" },
            { name: "Submitted by me", route: "submitted-by-me" },
          ],
        },
        {
          name: "Risk",
          mainRoute: "key-risk",
          route: "all-risk",
          childMenu: [
            { name: "All", route: "all-risk" },
            { name: "Pending", route: "pending-approval-risk" },
            { name: "Submitted by me", route: "risk-submitted-by-me" },
          ],
        },
        {
          name: "Key Clearance",
          mainRoute: "key-clearance",
          route: "all-clearance",
        },
        {
          name: "Safety",
          mainRoute: "key-safety",
          route: "all-safety",
        },
        // {
        //   name: "Claims",
        //   mainRoute: "key-claims",
        //   route: "all-claims",
        // },
        {
          name: "Quality",
          mainRoute: "key-quality",
          route: "all-quality",
        },
      ],
    },

    // {
    //   menu: "Image Gallery",
    //   icon: <IoMdImages style={{ height: "20px", width: "20px" }} />,
    //   mainRoute: "image-gallery",
    //   route: "image-gallery/all-images",
    // }

    {
      menu: "Image Gallery",
      icon: <ImageIcon style={{ height: "27px", width: "27px", fill: "#696969", stroke: "#696969", strokeWidth: 2 }} />,
      mainRoute: "image-gallery",
      route: "image-gallery/all-images",
      permissionKey: [IMAGE_GALLERY_ACCESS],
    },

    {
      menu: "DPR",
      icon: <DprView style={{ height: "27px", width: "27px", fill: "#696969", stroke: "#696969", strokeWidth: 2 }} />,
      route: false,
      permissionKey: [DPR_QUANTITY_ACCESS, DPR_PM_ACCESS],
      submenus: [
        {
          name: "Schedule",
          mainRoute: "dpr",
          route: "Quantity_list",
        },
        {
          name: "P&M",
          mainRoute: "dpr_pmList",
          route: "PM_list",
          childMenu: [
            { name: "All", route: "PM_list" },
            { name: "Submitted by me", route: "dprPm-submitted-by-me" },
          ],
        },
      ]
    },
    {
      menu: "Report",
      icon: <ReportIcon style={{ height: "27px", width: "27px", fill: "#696969", stroke: "#696969", strokeWidth: 2 }} />,
      route: false,
      submenus: [
        { name: "Report Generator", mainRoute: "report", route: "report-generator" },
        { name: "My Reports", mainRoute: "report", route: "my-reports" },
      ],
    },
    {
      menu: "Config & Settings",
      icon: <ConfigSettingIcon style={{ height: "27px", width: "27px", fill: "#696969", stroke: "#696969", strokeWidth: 2 }} />,
      route: false,
      permissionKey: [PROJECT_SETTING_ACCESS, NORMS_ACCESS, WORKFLOW_ACCESS, DATA_METRICS_ACCESS],
      submenus: [
        {
          name: "Project Settings",
          mainRoute: "project-settings",
          route: "all-settings",
        },
        {
          name: "Norms",
          mainRoute: "norms",
          route: "all-norms",
        },
        {
          name: "Workflow Management",
          mainRoute: "workflow",
          route: "all-workflow",
        },
        {
          name: "Data Alert Management",
          mainRoute: "data-alert-management",
          route: "all-data-alert-management",
        },
      ],
    },
    {
      menu: "Help",
      icon: <HelpIcon style={{ height: "27px", width: "27px", fill: "#696969", stroke: "#696969", strokeWidth: 2 }} />,
      route: false,
      permissionKey: [HELP_FEATURE_LIST_ACCESS, HELP_DATA_SETS_LIST_ACCESS],
      submenus: [
        {
          name: "Feature List",
          mainRoute: "faq",
          route: "feature-list",
        },
        {
          name: "Data Sets",
          mainRoute: "faq",
          route: "data-sets",
        },
      ],
    },
  ],

  headerMenus: [
    {
      menu: "Key Issues",
      route: "key-issues",
      isTopBar: true,
      submenus: [
        { name: "All", route: "all-issue" },
        // { name: "Pending for approval", route: "pending-approval" },
        { name: "Submitted by me", route: "submitted-by-me" },
      ],
    },

    {
      menu: "P&M DPR",
      route: "dpr_pmList",
      isTopBar: true,
      submenus: [
        { name: "All", route: "PM_list" },
        { name: "Submitted by me", route: "dprPm-submitted-by-me" },
      ],
    },
    {
      menu: "Schedule DPR",
      route: "dpr",
      isTopBar: true,
      submenus: [
        { name: "All", route: "Quantity_list" },
        { name: "Submitted by me", route: "Quantity_list_submitted_by_me" },
      ],
    },
    // {
    //   menu: "Create New Dpr",
    //   route: "new_dpr",
    //   isTopBar: true,

    // },

    {
      menu: "BOQ",
      route: "key-BOQ",
      isTopBar: true,
      submenus: [
        { name: "All", route: "all-BOQ" },
        { name: "Submitted by me", route: "boqSubmitted" },
      ],
    },

    {
      menu: "Risk",
      img: userList,
      route: "key-risk",
      isTopBar: true,
      submenus: [
        { name: "All", route: "all-risk" },
        // { name: "Pending for approval", route: "pending-approval-risk" },
        { name: "Submitted by me", route: "risk-submitted-by-me" },
      ],
    },
    {
      menu: "Safety",
      img: userList,
      route: "key-safety",
      isTopBar: true,
      submenus: [
        { name: "All", route: "all-safety" },
        // { name: "Pending for approval", route: "pending-approval-safety" },
        { name: "Submitted by me", route: "safety-submitted-by-me" },
      ],
    },
    {
      menu: "Key Clearance",
      img: userList,
      route: "key-clearance",
      isTopBar: true,
      submenus: [
        { name: "All", route: "all-clearance" },
        // { name: "Pending for approval", route: "pending-approval-clearance" },
        { name: "Submitted by me", route: "clearance-submitted-by-me" },
      ],
    },
    {
      menu: "Change Order",
      img: userList,
      route: "key-change-tracker",
      isTopBar: true,
      submenus: [
        { name: "All", route: "all-change-tracker" },
        // {
        //   name: "Pending for approval",
        //   route: "pending-approval-change-tracker",
        // },
        { name: "Submitted by me", route: "change-tracker-submitted-by-me" },
      ],
    },
    {
      menu: "Claims",
      img: userList,
      route: "key-claims",
      isTopBar: true,
      submenus: [
        { name: "All", route: "all-claims" },
        // { name: "Pending for approval", route: "pending-approval-claims" },
        { name: "Submitted by me", route: "claims-submitted-by-me" },
      ],
    },
    {
      menu: "Quality",
      img: userList,
      route: "key-quality",
      isTopBar: true,
      submenus: [
        { name: "All", route: "all-quality" },
        // { name: "Pending for approval", route: "pending-approval-quality" },
        { name: "Submitted by me", route: "quality-submitted-by-me" },
      ],
    },
    {
      menu: "Plant & Machinery",
      img: userList,
      route: "key-p&m",
      isTopBar: true,
      submenus: [
        { name: "All", route: "all-p&m" },
        // { name: "Pending for approval", route: "pending-approval-p&m" },
        { name: "Submitted by me", route: "p&m-submitted-by-me" },
      ],
    },
    {
      menu: "Milestone",
      img: userList,
      route: "key-milestone",
      isTopBar: true,
      submenus: [
        { name: "All", route: "all-milestone" },
        // {
        //   name: "Pending for approval",
        //   route: "pending-approval-milestone",
        // },
        { name: "Submitted by me", route: "milestone-submitted-by-me" },
      ],
    },
    {
      menu: "Manpower",
      img: userList,
      route: "key-manpower",
      isTopBar: true,
      submenus: [
        { name: "All", route: "all-manpower" },
        { name: "Pending for approval", route: "pending-approval-manpower" },
        { name: "Submitted by me", route: "submitted-by-me-manpower" },
      ],
    },
    {
      menu: "File",
      img: userList,
      route: "key-file",
      isTopBar: true,
      submenus: [
        { name: "All", route: "all-file" },
        { name: "Pending for approval", route: "pending-approval-file" },
        { name: "Submitted by me", route: "file-submitted-by-me" },
      ],
    },

    {
      menu: "Engineering",
      img: userList,
      route: "engineering",
      isTopBar: true
    },
    {
      menu: "Monte Carlo Simulation",
      img: userList,
      route: "monte-carlo-simulation",
      isTopBar: true
    },
    {
      menu: "Bim Viewer",
      img: userList,
      route: "bim-viewer",
      isTopBar: true
    },
    {
      menu: "Image Gallery",
      img: userList,
      route: "image-gallery",
      isTopBar: true,
      permissionKey: [IMAGE_GALLERY_ACCESS, IMAGE_GALLERY_APPROVAL, IMAGE_GALLERY_ACCESS],
      submenus: [
        { name: "All", route: "all-images" },
        { name: "Pending for approval", route: "pending-approval-images" },
        { name: "Submitted by me", route: "images-submitted-by-me" },
      ],
    },
    {
      menu: "Document Repository",
      img: userList,
      route: "documents",
      isTopBar: true,
      submenus: [
        { name: "All", route: "all-documents" },
        // { name: "Pending for approval", route: "pending-approval-documents" },
        { name: "Submitted by me", route: "documents-submitted-by-me" },
      ],
    },
    {
      menu: "Norms",
      img: userList,
      route: "norms",
      isTopBar: true,
    },
    {
      menu: "Project Settings",
      img: userList,
      route: "project-settings",
      isTopBar: true,
    },
    {
      menu: "Workflow Management",
      img: userList,
      route: "workflow",
      isTopBar: true,
    },
    {
      menu: "Data Metrics Management",
      img: userList,
      route: "data-alert-management",
      isTopBar: true,
    },
    {
      menu: "Schedule",
      img: userList,
      route: "key-schedule",
      isTopBar: true,
    },
  ],

  projectDashboardMenus: [
    {
      menu: "Project Landing",
      img: userList,
      route: "project-landing",
    },
    {
      menu: "My Work",
      img: roleManager,
      route: "my-work",
    },
  ],
  topMenus: [
    // {
    //   menu: "Portfolio Dashboard",
    //   icon: menuIcon,
    //   isLeftMenu: false,
    //   permissionKey: [PORTFOLIO_DASHBOARD_MENU],
    //   rolesAllowed: ["SystemAdmin"],
    //   submenus: [
    //     {
    //       name: "Portfolio Dashboard",
    //       icon: userList,
    //       route: "portfolio-dashboard",
    //     },
    //   ],
    // },
    {
      menu: "Program Dashboard",
      icon: menuIcon,
      isLeftMenu: false,
      route: "program-dashboard/program-dashboard",
      permissionKey: [PROGRAM_DASHBOARD_MENU],
       rolesAllowed: MAIN_ROLES,
      // submenus: [
      //   {
      //     name: "Program Dashboard",
      //     icon: userList,
      //     route: "program-dashboard",
      //   },
      // ],
    },
    {
      menu: "Projects",
      icon: menuIcon,
      permissionKey: [PROJECT_MENU],
      route: "projects/project-creation/project-list",
      rolesAllowed: MAIN_ROLES,
      //   submenus: [
      //     // { name: "User List", icon: userList, route: "project-creation/project-list" },
      //     // { name: "Role Manager", icon: roleManager, route: "role-manager" },
      //   ],
      isLeftMenu: false,
    },
    {
      menu: "User Management",
      // icon: menuIcon,
      icon: <MenuNewIcon style={{ height: "27px", width: "27px", fill: "#696969", stroke: "#696969", strokeWidth: 2 }} />,
      permissionKey: [USER_MANAGEMENT_MENU],
      route: 'user-management',
      rolesAllowed: [MAIN_ROLES[0]],
      submenus: [
        { name: "User List", icon: <UserlistIcon style={{ height: "27px", width: "27px", fill: "#696969", stroke: "#696969", strokeWidth: 2 }} />, route: "user-list" },
        // { name: "Role Manager", icon: roleManagerI, route: "role-manager" },
        // { name: "Role Manager", icon: roleManagerIcon, route: "role-manager" },
        {
          name: "Bulk User Transaction",
          //  icon: roleManager,
          icon: <RoleManagerIcon style={{ height: "27px", width: "27px", fill: "#696969", stroke: "#696969", strokeWidth: 2 }} />,
          route: "transactions",
        },
      ],
      isLeftMenu: true,
    },
    // {
    //   menu: "Data",
    //   icon: menuIcon,
    //   submenus: [
    //     { name: "User List", icon: userList, route: "user-list" },
    //     { name: "Role Manager", icon: roleManager, route: "role-manager" },
    //     { name: "Transactions", icon: roleManager, route: "transactions" },
    //   ],
    //   isLeftMenu: true,
    // },
    // {
    //   menu: "Document",
    //   icon: menuIcon,
    //   submenus: [
    //     { name: "User List", icon: userList, route: "user-list" },
    //     { name: "Role Manager", icon: roleManager, route: "role-manager" },
    //     { name: "Transactions", icon: roleManager, route: "transactions" },
    //   ],
    //   isLeftMenu: true,
    // },
    // {
    //   menu: "Workflow",
    //   icon: menuIcon,
    //   submenus: [
    //     { name: "User List", icon: userList, route: "user-list" },
    //     { name: "Role Manager", icon: roleManager, route: "role-manager" },
    //     { name: "Transactions", icon: roleManager, route: "transactions" },
    //   ],
    //   isLeftMenu: true,
    // },
    // {
    //   menu: "Integrations",
    //   icon: menuIcon,
    //   submenus: [
    //     { name: "User List", icon: userList, route: "user-list" },
    //     { name: "Role Manager", icon: roleManager, route: "role-manager" },
    //     { name: "Transactions", icon: roleManager, route: "transactions" },
    //   ],
    //   isLeftMenu: true,
    // },
  ],
};

export default projectMenus;
